import { useState } from 'react';

import { FormControlLabel, Switch, Typography } from '@mui/material';

import { themeColors } from 'colors';
import ContentBuilderRow from 'domains/core/components/ContentBuilderRow';
import { VoiceContentStateTypes } from 'pages/ContentVoiceBuilderPage/types';
import { setIncorrectResponseMessage } from 'pages/ContentVoiceBuilderPage/voiceCallActions';

const defaultIncorrestResponseMessage = 'You have entered an incorrect input. Please try again.';

type Props = {
    voiceContentState: VoiceContentStateTypes;
    dispatchVoiceContentAction: React.Dispatch<any>;
    isContentLoading: boolean;
};

const IncorrectResponseRow = ({ dispatchVoiceContentAction, voiceContentState: state, isContentLoading }: Props) => {
    const [isIncorrectResponseMessageEnabled, setIsIncorrectResponseMessageEnabled] = useState(
        !!state.voiceJson?.fallback?.incorrectResponseMessage?.length
    );

    return (
        <ContentBuilderRow
            title="Incorrect Response Message"
            subtitle="Set default messages to keep the call smooth, even if there's invalid response."
            content={
                <>
                    <FormControlLabel
                        control={
                            <Switch
                                color="secondary"
                                checked={isIncorrectResponseMessageEnabled}
                                onChange={(e) => {
                                    setIsIncorrectResponseMessageEnabled(!isIncorrectResponseMessageEnabled);
                                    if (e.target.checked) {
                                        dispatchVoiceContentAction(
                                            setIncorrectResponseMessage(defaultIncorrestResponseMessage)
                                        );
                                    } else {
                                        dispatchVoiceContentAction(setIncorrectResponseMessage(''));
                                    }
                                }}
                                size="small"
                            />
                        }
                        disabled={isContentLoading}
                        label={
                            <Typography color={themeColors.text.primary} variant="body2">
                                Play incorrect response message
                            </Typography>
                        }
                    />
                    <Typography color={themeColors.text.disabled} ml="30px" variant="body2">
                        "{defaultIncorrestResponseMessage}"
                    </Typography>
                </>
            }
        />
    );
};

export default IncorrectResponseRow;
